import { Instance, instanceSettings } from '@ekd/portal-connector/dist/Instance';

@instanceSettings({ name: 'root' })
export class RootInstance extends Instance {
  public alert({ type, title, text }: { type: string; title: string; text?: string }) {
    this.context.store.commit('alert', { type, title, text });
  }
}
